import type { PlayerControl } from '../../types';

export const getPlayerControls = (
  controls: PlayerControl[],
  existingPlayerControls: PlayerControl[],
  playerControls: PlayerControl[]
) => {
  if (!existingPlayerControls || !playerControls) return controls;

  return controls.filter((control) => {
    return existingPlayerControls.includes(control)
      ? playerControls.includes(control)
      : true;
  });
};
